import { Box, Skeleton } from '@mui/material';

const SKELETON_ROW_WIDTHS = [92, 78, 85, 67, 74] as const;

export const LoadingSkeleton = () => {
  return (
    <Box>
      {SKELETON_ROW_WIDTHS.map((width, i) => (
        <Skeleton key={i} variant="text" width={`${width}%`} height={20} />
      ))}
    </Box>
  );
};
